import { routes as strategiesRoutes } from "@Quest/Strategies/routes";
import { routes as portfoliosRoutes } from "@Quest/Portfolios/routes";
import { routes as projectsRoutes } from "@Quest/Projects/routes";
import { routes as projectPlansRoutes } from "@Quest/ProjectPlans/routes";
import { routes as projectPlanTemplatesRoutes } from "@Quest/ProjectPlanTemplates/routes";
import { routes as capexRoutes } from "@Quest/Capex/routes";
import { routes as costsRoutes } from "@Quest/Costs/routes";
import { routes as revenuesRoutes } from "@Quest/Revenues/routes";
import { routes as corporateScenariosRoutes } from "@Quest/CorporateScenarios/routes";
import { routes as corporateAttributesRoutes } from "@Quest/CorporateAttributes/routes";
import { routes as portfolioScenariosRoutes } from "@Quest/PortfolioScenarios/routes";
import { routes as resourcesRoutes } from "@Quest/Resources/routes";
import { routes as metricsRoutes } from "@Quest/Metrics/routes";
import { routes as pnlsRoutes } from "@Quest/Pnls/routes";


export const routes = [
    ...strategiesRoutes,
    ...portfoliosRoutes,
    ...projectsRoutes,
    ...projectPlansRoutes,
    ...projectPlanTemplatesRoutes,
    ...capexRoutes,
    ...costsRoutes,
    ...revenuesRoutes,
    ...corporateScenariosRoutes,
    ...portfolioScenariosRoutes,
    ...resourcesRoutes,
    ...metricsRoutes,
    ...corporateAttributesRoutes,
    ...pnlsRoutes
]
